export default __webpack_public_path__ + "static/image-header-tablet-af8a135d3cc0e5e18e2e0d8d4d961c9d.png";